"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leaderboard = void 0;
var typeorm_1 = require("typeorm");
var Leaderboard = /** @class */ (function () {
    function Leaderboard() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], Leaderboard.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], Leaderboard.prototype, "userID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Leaderboard.prototype, "companyName", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], Leaderboard.prototype, "portfolio", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], Leaderboard.prototype, "time", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], Leaderboard.prototype, "profit", void 0);
    __decorate([
        (0, typeorm_1.Column)({ type: 'float' }),
        __metadata("design:type", Number)
    ], Leaderboard.prototype, "emissions", void 0);
    __decorate([
        (0, typeorm_1.CreateDateColumn)(),
        __metadata("design:type", Date)
    ], Leaderboard.prototype, "createdAt", void 0);
    Leaderboard = __decorate([
        (0, typeorm_1.Entity)({ name: 'leaderboard' })
    ], Leaderboard);
    return Leaderboard;
}());
exports.Leaderboard = Leaderboard;
//# sourceMappingURL=Leaderboard.entity.js.map